var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello"},[_c('br'),_c('br'),_c('h1',[_vm._v(" "+_vm._s(_vm.languages[_vm.language].home_welcome)+" ")]),_c('br'),_c('p',[_vm._v(" "+_vm._s(_vm.languages[_vm.language].home_team_description)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }